import * as React from 'react'
import { FC, useCallback, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Popover from '@mui/material/Popover'
import { ISoldServiceStatusSummary } from '../typings'
import { SoldServicesStatusSummaryCard } from '../SoldServicesStatusSummaryCard'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { ClosedWonQueueLink } from '../../ClosedWonQueueLink/ClosedWonQueueLink'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { getStyles } from './styling'
import { useTheme } from '@mui/material/styles'

export interface Props {
  onManageClick?: (status: SOLD_SERVICE_STATUS) => void
  summaries: ISoldServiceStatusSummary[]
}

export const SoldServiceStatusSummaryPopover: FC<Props> = (props) => {
  const { onManageClick, summaries } = props

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? 'sold-service-status-summary-popover' : undefined

  const onClose = useCallback(() => setAnchorEl(null), [])
  const onOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget)
  }

  const handleManageClick = useCallback(
    (status: SOLD_SERVICE_STATUS) => {
      onClose()
      if (onManageClick) onManageClick(status)
    },
    [onClose, onManageClick],
  )
  const styles = getStyles(useTheme())
  return (
    <>
      <Button sx={styles.viewButton} variant="text" onClick={onOpen}>
        View Status Breakdown{' '}
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </Button>
      <Popover
        id={id}
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          onMouseLeave: onClose,
          elevation: 3,
          style: { maxWidth: '1000px' },
        }}
      >
        <Box sx={styles.container}>
          <Box>
            <Button sx={styles.viewButton} variant="text" onClick={onClose}>
              View Status Breakdown <KeyboardArrowUpIcon />
            </Button>
          </Box>
          <Divider sx={styles.divider} />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            {summaries &&
              summaries.map((summary, index) => (
                <SoldServicesStatusSummaryCard
                  key={index}
                  onManageClick={() =>
                    handleManageClick(summary.soldServiceStatus)
                  }
                  {...summary}
                />
              ))}
          </Box>
          <Box sx={styles.closedWonQueueLink}>
            <ClosedWonQueueLink onClick={onClose} />
          </Box>
        </Box>
      </Popover>
    </>
  )
}
SoldServiceStatusSummaryPopover.displayName = 'SoldServiceStatusSummaryPopover'
